import { useGameService } from '~/composables/services/useGameService';
import { useCachebust } from '~/composables/useStates/useCachebust';

export default defineNuxtRouteMiddleware(async (_, from) => {
  const { setCacheBust } = useCachebust();
  const auth = useAuthStore();
  const $gameService = useGameService();
  if (!!from.params?.game && !!auth.loggedIn) {
    setCacheBust('personalised');
    await $gameService.fetchPersonalisedGames();
  }
});
